export default __webpack_public_path__ + "static/media/Procedure-Technicians.e1addfda.jpg";